<template>
  <el-dialog title="查看分配结果" :visible.sync="visible" width="1000px">
    <c-table
      class="mt-4"
      :data="dataSource"
      :columns="columns"
      :showPagination="false"
    >
      <template slot="count" slot-scope="{row}">
        <div v-if="row.sampling_num">待取样：{{ row.sampling_num }}</div>
        <div>待装卸：{{ row.unload_num }}</div>
      </template>
    </c-table>
    <span slot="footer" class="dialog-footer">
        <el-button @click="hide">关 闭</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      uuid: "",
      visible: false,
      columns: [
        { label: "总排队号", prop: "total_seq" },
        { label: "车辆类型排队号", prop: "business_seq" },
        { label: "车辆号码", prop: "license_plate" },
        { 
          label: "取样点", 
          prop: "sampling_point_name", 
          headerClass: "text-red-600",
          rowClass: () => {
            return "text-red-600";
          }
        },
        { 
          label: "装卸点", 
          prop: "warehouse_name", 
          headerClass: "text-red-600",
          rowClass: () => {
            return "text-red-600";
          }
        },
        { 
          label: "当前装卸点情况", 
          prop: "count",
          // formatData: (row) => {
          //   return `待装卸：${row.unload_num || 0}`
          // }
        },
        { 
          label: "备注说明", 
          prop: "result_type",
          formatData: (row) => {
            let text = "";
            switch (row.result_type) {
              case 1:
                text = "自助取样点->装卸点";
                break; 
              case 2:
                text = "装卸点取样+装卸一体";
                break; 
              case 3:
                text = "自助取样点->加抽->装卸点";
                break;
              default:
                text = "--";
                break;
            }
            return text;
          }
        }
      ],
      dataSource: []
    };
  },
  methods: {
    async getCallResult() {
      const res = await this.$common.http({
        url: "/api/queue/admin/query_call_result",
        data: {
          uuid: this.uuid
        }
      });
      this.dataSource = res.data.data;
    },
    show(uuid) {
      this.uuid = uuid;
      this.$nextTick(() => {
        this.visible = true;
        this.getCallResult();
      });
    },
    hide() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped></style>
